"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _propTypes = require("prop-types");
var _mediaQueries = _interopRequireDefault(require("../shared/mediaQueries"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var OuterSection = /*#__PURE__*/
(0, _reactEmotion.default)('section', {
  target: "ek901620"
})(function (props) {
  var _ref;
  return _ref = {
    background: props.background || 'transparent',
    padding: '80px 50px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden'
  }, _ref[(0, _mediaQueries.default)('md')] = {
    padding: '50px 25px'
  }, _ref;
});
var InnerSection = /*#__PURE__*/
(0, _reactEmotion.default)('div', {
  target: "ek901621"
})(function (props) {
  var _ref2;
  return _ref2 = {
    maxWidth: props.maxWidth || 1200,
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: props.columns || '1fr 1fr',
    gridGap: 50,
    alignItems: 'center'
  }, _ref2[(0, _mediaQueries.default)('md')] = {
    gridTemplateColumns: '1fr',
    justifyItems: 'center'
  }, _ref2;
});
var Section = function Section(_ref3) {
  var children = _ref3.children,
    innerSectionProps = _ref3.innerSectionProps,
    props = _objectWithoutProperties(_ref3, ["children", "innerSectionProps"]);
  return _react.default.createElement(OuterSection, props, _react.default.createElement(InnerSection, innerSectionProps, children));
};
Section.propTypes = {
  children: _propTypes.node,
  innerSectionProps: _propTypes.object
};
var _default = Section;
exports.default = _default;